import {useState} from "react";

import {ATTITUDES} from "@/utils/scoutingData";

import "./index.scss";

const KIND_LABEL = {per90: "per 90'", ratio: "%", diff90: "per 90'"};

const formatValue = (value, kind) =>
	value === null || value === undefined
		? "—"
		: value.toLocaleString("it-IT", {
				maximumFractionDigits: kind === "ratio" ? 1 : 2,
			}) + (kind === "ratio" ? "%" : "");

const round = (value) => (value === null ? "—" : Math.round(value));

// Card di un indice 0–100: barra con tacca della media in carriera, scarto, andamento e formula.
export default function IndexCard({index, history, marked}) {
	const [open, setOpen] = useState(false);
	const attitude = ATTITUDES.find((a) => a.id === index.attitude);
	const color = attitude?.color || "var(--color-primary)";
	const score = index.score;
	const career = history?.career ?? null;
	const delta = score !== null && career !== null ? score - career : null;
	const trend = (history?.bySeason || []).slice().reverse();

	return (
		<div className="index-card" style={{"--index-color": color}}>
			<div className="index-card__head">
				{attitude && <span className="index-card__code">{attitude.id}</span>}
				<span className="index-card__label">{index.label}</span>
				<span className="index-card__score">{round(score)}</span>
			</div>
			<div
				className="index-card__bar"
				role="img"
				aria-label={
					index.label +
					": " +
					round(score) +
					" su 100" +
					(career !== null ? ", media in carriera " + round(career) : "")
				}
			>
				<span style={{width: (score || 0) + "%"}} />
				{career !== null && (
					<i className="index-card__tick" style={{left: career + "%"}} />
				)}
			</div>
			<div className="index-card__meta">
				{delta !== null && (
					<span
						className={
							"index-card__delta" + (delta >= 0 ? " is-up" : " is-down")
						}
					>
						{(delta >= 0 ? "+" : "−") + Math.abs(Math.round(delta))} vs carriera
					</span>
				)}
				{attitude && marked && (
					<span className="index-card__marked">Attitudine in scheda</span>
				)}
			</div>
			{trend.length > 1 && (
				<div className="index-card__trend" aria-label="Andamento per stagione">
					{trend.map((s) => (
						<span
							key={s.season}
							title={s.season + ": " + round(s.score)}
							style={{height: Math.max(2, (s.score || 0) * 0.28) + "px"}}
							className={s.score === null ? "is-empty" : ""}
						/>
					))}
				</div>
			)}
			<button
				type="button"
				className="index-card__toggle"
				aria-expanded={open}
				onClick={() => setOpen(!open)}
			>
				{open ? "Nascondi formula" : "Componenti e formula"}
			</button>
			{open && (
				<table className="index-card__components">
					<thead>
						<tr>
							<th>Componente</th>
							<th>Valore</th>
							<th>Punti</th>
							<th>Peso</th>
						</tr>
					</thead>
					<tbody>
						{index.components.map((c) => (
							<tr key={c.label}>
								<td>
									{c.label}
									<small>
										scala {formatValue(c.min, c.kind)} –{" "}
										{formatValue(c.max, c.kind)}
										{c.kind !== "ratio" ? " " + KIND_LABEL[c.kind] : ""}
									</small>
								</td>
								<td>{formatValue(c.value, c.kind)}</td>
								<td>{round(c.score)}</td>
								<td>{c.weight}%</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	);
}
